import { Marker } from '@retailer-platform/shared-components/src/tds'
import { type NavMenuHierarchyL2 } from '../../nav-v2/NavMenuHierarchy'
import { useDashIntl, useDashMessages } from '../../../../intl/intl.hooks'
import { SPACING } from '../constants'

interface PermissionMarkersProps {
  tool: NavMenuHierarchyL2
  selectedPermissionSlugs: Set<string>
}

export const PermissionMarkers = ({ tool, selectedPermissionSlugs }: PermissionMarkersProps) => {
  const dashIntl = useDashIntl()
  const i18n = useDashMessages({
    noRestrictions: 'dashboard.permissions.marker.noRestrictions',
    notApplicable: 'dashboard.permissions.marker.notApplicable',
  })

  const allInToolPermissionsChecked =
    tool.inToolPermissions?.every(permission => selectedPermissionSlugs.has(permission.slug)) ||
    (tool.inToolPermissions || []).length === 0

  const inToolPermissionsChecked = tool.inToolPermissions?.filter(permission =>
    selectedPermissionSlugs.has(permission.slug)
  )

  let markers
  if (allInToolPermissionsChecked) {
    markers = [
      <div key={tool.name + '_' + 'no-restrictions'} css={{ display: 'flex' }}>
        <Marker key={`${tool.name}-no-restrictions`} text={i18n.noRestrictions} variant="success" />
      </div>,
    ]
  } else if (inToolPermissionsChecked && inToolPermissionsChecked.length > 0) {
    markers = inToolPermissionsChecked.map(permission => (
      <div key={tool.name + '_' + permission.slug} css={{ display: 'flex' }}>
        <Marker
          text={dashIntl.formatMessage({
            id: ('permissionAccordion.permissions.' + permission.slug) as any,
          })}
          variant="detrimental"
        />
      </div>
    ))
  } else {
    markers = [
      <div key={tool.name + '_' + 'not-applicable'} css={{ display: 'flex' }}>
        <Marker key={tool.name + '_' + 'alert'} text={i18n.notApplicable} variant="alert" />
      </div>,
    ]
  }

  return (
    <div css={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', gap: SPACING.SMALL }}>
      {markers}
    </div>
  )
}
